import { FC } from 'react'
import { IBusinessLabel } from '../../model/labels'
import { LabelBadge } from './LabelBadge'
import classes from './labels.module.scss'

export const LabelBadges: FC<{labels?: IBusinessLabel[]}> = ({labels = []}) => {
    if(!labels.length) return null
    return <section className={classes.badges}>{labels.map(label => <LabelBadge key={`${label.text}-${label.background_color}`} label={label} />)}</section>
}
